import { api } from './api';

const eventURL = '/event';

export const eventApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllEvents: builder.query({
      query: () => eventURL,
      providesTags: ['Event'],
    }),
    getAllEventsWithRubricGrades: builder.query({
      query: () => `${eventURL}/eventRubricGrade`,
      providesTags: ['Event'],
    }),
    getEventsByCamp: builder.query({
      query: campId => `${eventURL}/filter/${campId}`,
    }),
  }),
});

export const {
  useGetAllEventsQuery,
  useGetAllEventsWithRubricGradesQuery,
  useLazyGetEventsByCampQuery,
  useGetEventsByCampQuery,
} = eventApi;
